export const ttlockConfig = {
  credentials: {
    title: "Configuration TTLock",
    subtitle: "Saisissez les identifiants de votre compte TTLock",
    savedBadge: "Identifiants enregistrés",
    noneBadge: "Aucun identifiant",
    emailLabel: "L'e-mail de votre compte TTLock",
    emailPlaceholder: "you@example.com",
    emailHelp: "L'e-mail que vous utilisez pour vous connecter à TTLock",
    passwordLabel: "Mot de passe",
    passwordPlaceholderSaved: "•••••••• (enregistré, modification facultative)",
    passwordPlaceholder: "Votre mot de passe TTLock",
    passwordHelpSaved: "Vous pouvez le laisser vide si vous en avez déjà un enregistré.",
    passwordHelp: "Le mot de passe de votre compte TTLock.",
    testing: "Test en cours...",
    testConnection: "Tester la connexion",
    saving: "Enregistrement...",
    saveCredentials: "Enregistrer les identifiants",
  },
  selector: {
    title: "Sélecteur de serrures pour cette propriété",
    subtitleBefore: "Sélectionnez uniquement les serrures qui concernent ",
    subtitleStrong: "cette propriété",
    subtitleAfter: ".",
    selectedCount: "{count} sélectionnée | {count} sélectionnées",
    hintBefore: "Saisissez vos identifiants et appuyez sur ",
    hintStrong: "Tester la connexion",
    hintAfter: " pour charger vos serrures.",
    noneFound: "Aucune serrure trouvée. Vérifiez votre compte TTLock.",
    placeholder: "Sélectionnez des serrures…",
    summaryCount: "{count} serrure sélectionnée | {count} serrures sélectionnées",
    emptySelection: "Aucune serrure sélectionnée",
    saving: "Enregistrement...",
    save: "Enregistrer les serrures pour cette propriété",
  },
  gateway: {
    with: "Avec Gateway",
    without: "Sans Gateway",
  },
  pms: {
    title: "Contrôle et attribution (PMS)",
    subtitleP1: "Attribuez chaque serrure à ",
    subtitleStrongMain: "Porte principale",
    subtitleP2: " ou ",
    subtitleStrongUnit: "Unité",
    subtitleP3: ".",
    assignedCount: "{count} attribuée | {count} attribuées",
    empty: "Vous n'avez pas encore de serrures enregistrées pour cette propriété.",
    assignmentLabel: "Attribution",
    assignmentNone: "Non attribuée",
    assignmentCommon: "Porte principale (partagée)",
    assignmentUnit: "Porte de l'appartement",
    hintNone: "Elle ne sera pas contrôlée depuis le PMS.",
    hintAssigned: "Elle sera liée à cette propriété pour le contrôle/les codes PIN.",
    unitLabel: "Unité / Hébergement",
    unitSelectPlaceholder: "Sélectionnez une unité",
    unitHint: "Sélectionnez l'unité que cette serrure ouvre.",
    nameLabel: "Nom (facultatif)",
    namePlaceholder: "p. ex. Porte principale / Apt 101",
    saving: "Enregistrement...",
    save: "Enregistrer l'attribution",
  },
  actions: {
    lock: "Verrouiller",
    unlock: "Déverrouiller",
    requiresGateway: "Nécessite Gateway",
    createPasscode: "Créer un code d'accès",
    passcodeHistory: "Historique des codes d'accès",
    refreshStatus: "Actualiser l'état",
  },
  lockFallbackName: "Serrure {id}",
  unitFallbackName: "Unité {id}",
  history: {
    title: "Historique des codes d'accès",
    revocationTitle: "À propos de la révocation des codes :",
    withGatewayLabel: "Avec gateway :",
    withGatewayText: "Le code est révoqué immédiatement sur la serrure physique.",
    withoutGatewayLabel: "Sans gateway :",
    withoutGatewayText:
      "Le code est supprimé du serveur TTLock, mais il continuera de fonctionner sur la serrure jusqu'à ce que quelqu'un se connecte via Bluetooth depuis l'application mobile et effectue une synchronisation.",
    loading: "Chargement de l'historique…",
    empty: "Aucun code d'accès enregistré pour cette serrure.",
    colAlias: "Alias",
    colPasscode: "Code d'accès",
    colValidity: "Validité",
    colStatus: "Statut",
    createdAt: "Créé : {date}",
    fromLabel: "Du :",
    toLabel: "Au :",
    revokedTitle: "Déjà révoqué",
    revokeTitle: "Supprimer / Révoquer le code d'accès",
    close: "Fermer",
  },
  passcodeModal: {
    title: "Créer un code d'accès temporaire",
    nameLabel: "Nom / Étiquette",
    namePlaceholder: "p. ex. Ménage / Client / Technicien",
    nameHint: "Ce nom vous aidera à identifier le code.",
    validFrom: "Valide à partir du",
    validTo: "Valide jusqu'au",
    importantLabel: "Important :",
    importantText:
      "Le code sera généré automatiquement par TTLock et disponible uniquement pendant la période spécifiée. Le client peut saisir ce code directement sur le clavier de la serrure (cela fonctionne sans internet).",
    noGatewayLabel: "Sans Gateway :",
    noGatewayText:
      "Cette serrure n'a aucun gateway connecté. Les codes générés fonctionneront parfaitement sur le clavier physique, mais vous ne pourrez pas les révoquer à distance depuis ce panneau. Pour révoquer, vous devrez le faire depuis l'application TTLock en vous connectant via Bluetooth.",
    cancel: "Annuler",
    creating: "Création...",
    create: "Créer le code d'accès",
  },
  states: {
    active: "Actif",
    upcoming: "À venir",
    expired: "Expiré",
    revoked: "Révoqué",
    noDate: "Aucune date",
  },
  confirm: {
    revoke:
      `Êtes-vous sûr de vouloir révoquer/supprimer le code d'accès "{alias}" ?\n\nRemarque : si la serrure n'a aucun gateway, la révocation peut n'être que partielle.`,
  },
  toast: {
    noLocksFound: "Aucune serrure trouvée dans TTLock.",
    loadStatusError: "Impossible de charger l'état de la serrure",
    loadStatusErrorGeneric: "Erreur lors du chargement de l'état de la serrure",
    credentialsRequired: "Vous devez saisir un nom d'utilisateur et un mot de passe, ou avoir des identifiants enregistrés.",
    connectionOk:
      "Connexion réussie. {count} appareil trouvé. | Connexion réussie. {count} appareils trouvés.",
    testError: "Erreur lors du test de la connexion",
    credentialsSaved: "Identifiants enregistrés avec succès",
    saveCredentialsError: "Erreur lors de l'enregistrement des identifiants",
    saveCredentialsErrorDetail: "Erreur lors de l'enregistrement des identifiants : {msg}",
    selectAtLeastOne: "Vous devez sélectionner au moins un appareil pour cette propriété.",
    devicesSaved: "Appareils enregistrés pour cette propriété",
    devicesSaveError: "Impossible d'enregistrer les appareils",
    saveErrorDetail: "Erreur lors de l'enregistrement : {msg}",
    unitRequired: "Sélectionnez l'unité pour les serrures attribuées comme « Porte de l'appartement ».",
    bindingsSaved: "Attribution enregistrée avec succès",
    bindingsSaveError: "Impossible d'enregistrer l'attribution",
    bindingsSaveErrorDetail: "Erreur lors de l'enregistrement de l'attribution : {msg}",
    assignFirst: "Attribuez d'abord la serrure (porte principale ou unité) et enregistrez pour activer le contrôle.",
    passcodeNameRequired: "Vous devez fournir un nom/une étiquette pour le code d'accès.",
    passcodeDatesRequired: "Vous devez fournir une date de début et une date de fin de validité.",
    passcodeCreated: "Code d'accès créé : {code}",
    passcodeCreateError: "Impossible de créer le code d'accès",
    passcodeCreateErrorGeneric: "Erreur lors de la création du code d'accès",
    lockLocked: "Serrure verrouillée",
    lockLockError: "Impossible de verrouiller",
    lockLockErrorGeneric: "Erreur lors du verrouillage",
    lockUnlocked: "Serrure déverrouillée",
    lockUnlockError: "Impossible de déverrouiller",
    lockUnlockErrorGeneric: "Erreur lors du déverrouillage",
    revokeNoProviderId: "Ce code d'accès n'a pas de provider_passcode_id. Il ne peut pas être révoqué dans TTLock.",
    revokedOk: "Code d'accès entièrement révoqué",
    revokeError: "Impossible de révoquer",
    revokeErrorGeneric: "Erreur lors de la révocation du code d'accès",
    historyLoadError: "Impossible de charger l'historique",
    historyLoadErrorGeneric: "Erreur lors du chargement de l'historique",
  },
};
